(function($) {
	$(window).on("load", function() {
		$("a[rel='m_PageScroll2id']").mPageScroll2id({
			offset: 180
		});
	});
})(jQuery);